<template>
  <div id="header">
    <div id="header-left"><a :href="'//www.mg-lj.si/' + ($parent.alternateLang === 'en' ? 'si' : 'en') + '/'"><img src="./../assets/img/mg-msum-logo.svg" alt=""></a></div>
    <div id="header-right">
      <a class="hamburger" href="#" @click.prevent="openNavigationPanel()">&#9776;</a>
      <a class="backlink" href="#" @click.prevent="$parent.restart()">&#8635;</a>
      <a class="lang" href="#" @click="switchLanguage()">{{ $parent.alternateLang }}</a>
    </div>
  </div>
  
</template>

<script>
import AppNavigationPanel from './NavigationPanel.vue'
export default {
  name: 'app-header',
  methods: {
    switchLanguage() {
      window.location.href = this.$parent.alternateHref + window.location.hash
    },
    openNavigationPanel() {
      this.$showPanel({
        component: AppNavigationPanel,
        openOn: 'top',
        height: '80%',
        cssClass: 'my-slide-panel',
        props: {
          slides: this.$parent.slides,
          alternateLanguage: this.$parent.alternateLang
        }
      });
    }
  },
  created() {
    
    
  }
}
</script>

<style scoped>
#header {
  position: fixed;
  top: 0;
  height: 60px;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
}
#header-left {
  padding-left: 15px;
  padding-top: 10px;
}
#header-left a img {
    width: 225px;
    height: auto;
  }
#header .lang {
  text-transform: uppercase;
}
#header-right {
  padding-right: 25px;
  padding-top: 10px;
}
#header-right a {
  font-size: 24px;
  text-shadow: 0px 0px 4px rgba(51,51,51,0.5);
}
#header-right a.backlink {
  font-size: 30px;
  margin-right: 20px;
  display: inline-block;
  transform: rotate(90deg);
}
#header-right a.hamburger {
  font-size: 24px;
  margin-right: 20px;
  display: inline-block;
}

/* MEDIA QUERIES */
@media (max-width: 400px) {
  #header-left a img {
    width: 160px;
    height: auto;
  }
}
</style>